export default __webpack_public_path__ + "static/media/aboutUs_prev_ui.7eb8b666.png";